export default "__VITE_ASSET__CFJIKx$1__"